var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_1384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.55469 17.0832L10.0001 2.5L18.4456 17.0832H1.55469ZM3.70848 15.8333H16.2918L10.0001 4.99994L3.70848 15.8333ZM10.0001 14.8397C10.1909 14.8397 10.3507 14.7752 10.4797 14.6462C10.6087 14.5172 10.6732 14.3573 10.6732 14.1666C10.6732 13.9759 10.6087 13.816 10.4797 13.687C10.3507 13.558 10.1909 13.4935 10.0001 13.4935C9.80944 13.4935 9.64958 13.558 9.52058 13.687C9.39158 13.816 9.32708 13.9759 9.32708 14.1666C9.32708 14.3573 9.39158 14.5172 9.52058 14.6462C9.64958 14.7752 9.80944 14.8397 10.0001 14.8397ZM9.37517 12.6602H10.6251V8.49354H9.37517V12.6602Z",
    fill: "#FF871F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.3bcba593b04e0a6b0b6f34f99366226a.svg";
export { ForwardRef as ReactComponent };